import { Component, inject, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonIcon, IonItem, IonItemOption, IonItemOptions, IonItemSliding, IonList } from '@ionic/angular';
import { LetDirective } from '@ngrx/component';

import { NavigationService } from '@ninety/mobile/platform/state';

import { DiscussionListItem } from '../../../models/discussion.models';
import { DiscussionContextService } from '../../../services/context.service';
import { DiscussionListItemComponent } from '../discussion-list-item/discussion-list-item.component';

@Component({
  selector: 'nty-discussion-list',
  imports: [
    RouterModule,
    IonIcon,
    IonItem,
    IonItemOption,
    IonItemOptions,
    IonItemSliding,
    IonList,
    DiscussionListItemComponent,
    LetDirective,
  ],
  template: `
    <ion-list>
      @for (discussion of discussions; track discussion._id) {
        <ion-item-sliding
          *ngrxLet="context.userIsDiscussionParticipant(discussion) as isParticipant"
          [disabled]="!isParticipant">
          <ion-item
            detail="false"
            lines="full"
            [disabled]="!isParticipant"
            [routerLink]="nav.getDiscussionFormRoute(discussion._id)">
            <nty-discussion-list-item [discussion]="discussion" />
          </ion-item>
          <ion-item-options slot="end">
            <ion-item-option expandable [routerLink]="nav.getDiscussionDetailRoute(discussion._id)">
              <ion-icon slot="top" src="assets/icons/show--regular.svg" />
              <span class="terra-body-tiny view">View</span>
            </ion-item-option>
            @if (!isCompletedList) {
              <ion-item-option
                class="last-slider"
                expandable
                [routerLink]="nav.getDiscussionDetailEditRoute(discussion._id)">
                <ion-icon slot="top" src="assets/icons/edit--regular.svg" />
                <span class="terra-body">Edit</span>
              </ion-item-option>
            }
          </ion-item-options>
        </ion-item-sliding>
      }
    </ion-list>
  `,
  styles: `
    @use 'terra';

    :host {
      display: block;
      max-width: 93%;
      @include terra.radius(medium);
      margin: 0 auto;
    }

    ion-item-sliding {
      margin: 12px 0;
      border: 1px solid terra.color(border, light);
      cursor: pointer;
      @include terra.radius(medium);
      background: terra.color('background', heaviest);
    }

    ion-item-options {
      border-bottom-width: 0 !important;
    }

    ion-item-option {
      width: 100px;
      color: terra.color(text, light);
      background-color: transparent;

      ion-icon {
        color: terra.color(text, lightest);
        display: inline-block;
        margin-bottom: 2px;
        font-size: 24px;
      }

      .view {
        color: terra.color(text, light);
      }

      &.last-slider::before {
        content: '';
        font-size: 65px;
        border-left: 1px solid terra.color(border);
        pointer-events: none; /* Allows clicks to pass through */
        vertical-align: middle;
      }
    }

    ion-item {
      --min-height: 116px;
      --border-width: 0;
      --border-radius: #{terra.radius(medium)};
      --background: #{terra.color('background')};

      &::part(native) {
        @include terra.radius(none);
      }
    }

    ion-list {
      background: transparent;
    }
  `,
})
export class DiscussionListComponent {
  context = inject(DiscussionContextService);
  nav = inject(NavigationService);

  @Input({ required: true }) discussions: DiscussionListItem[] = [];
  @Input({ required: true }) isCompletedList!: boolean;
}
